import styles from "../../styles/PageBlocks.module.scss";
import React from "react";

const AtomicHeader = props => <h4 className = { styles.header } >{ props.text.toUpperCase() }</h4>

export default AtomicHeader;